import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { POST_DOCUMENT } from "./apiRoutes";

const mutateReversePostedDoc = async ({ data }: { data: any }) => {
  return await axiosAuth.post(`${POST_DOCUMENT}/reverse`, data);
};

const useReversePostedDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: any;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateReversePostedDoc,
    ...queryParams,
  });

export default useReversePostedDocMutation;
